import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import React from 'react';
import { useTranslation } from 'react-i18next';
const periodStyles = {
  future: {
    bg: '#D9E7FF',
    color: '#326AC2'
  },
  current: {
    bg: '#CDF5E3',
    color: '#048760'
  },
  past: {
    bg: '#F0F1F3',
    color: '#666A6F'
  }
};
function EventStatusSubtitle({
  event
}) {
  const {
    t
  } = useTranslation();
  const style = periodStyles[event.period];
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    gap: 2
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      color: '#2c2e30',
      fontSize: 16
    }
  }, `${event.startDate.format('D MMMM')} - ${event.endDate.format('D MMMM YYYY')}`), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: style.bg,
    borderRadius: 4,
    display: "flex",
    paddingX: 1.5,
    paddingY: 0.75
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      color: style.color,
      fontSize: 12,
      fontWeight: 800
    }
  }, event.period === 'past' ? t('commons.done') : t(`commons.periods.${event.period}`))));
}
export default EventStatusSubtitle;